export function checkThirdPartyCookies(): Promise<boolean | null> {
	const lastVerified = localStorage.getItem('thirdPartyCookiesVerified');
	if (lastVerified && parseInt(lastVerified, 16) + 86_400_000 > Date.now())
		return Promise.resolve(true);

	let resolveFn: (v: boolean | null) => void;
	let setScript: HTMLScriptElement | undefined;
	let checkScript: HTMLScriptElement | undefined;

	const cleanup = () => {
		delete window._cookieSet;
		delete window._cookieResult;
		setScript?.remove();
		checkScript?.remove();
	};

	const failTimeout = setTimeout(() => {
		resolveFn(null);
		cleanup();
	}, 5000);

	window._cookieSet = () => {
		window._cookieResult = result => {
			clearTimeout(failTimeout);
			resolveFn(result);
			result && localStorage.setItem('thirdPartyCookiesVerified', Date.now().toString(16));
			cleanup();
		};
		checkScript = addScript(process.env.VUE_APP_COOKIE_CHECK_CHECK_URL);
	};

	setScript = addScript(process.env.VUE_APP_COOKIE_CHECK_SET_URL);
	return new Promise(resolve => resolveFn = resolve);
}

function addScript(url: string): HTMLScriptElement {
	const script = document.createElement('script');
	script.src = url;
	script.async = true;
	document.body.append(script);
	return script;
}

declare global {
	interface Window {
		_cookieSet?: () => void;
		_cookieResult?: (r: boolean) => void;
	}
}
